import { Component } from 'js-component-framework';

export default class EmployeeDetail extends Component {
  constructor(config) {
    super(config);
    this.clickHandler = this.clickHandler.bind(this);
    this.showForm = this.showForm.bind(this);
    this.init();
  }

  clickHandler(event) {
    event.preventDefault();
    event.stopPropagation();
    this.showForm();
  }

  showForm() {
    // Get all forms and make sure they are hidden.
    const allForms = document.querySelectorAll('.employee__form');
    // eslint-disable-next-line no-return-assign
    [...allForms].forEach(({ style }) => style.display = 'none'); // eslint-disable-line no-param-reassign

    // Show the form the user actually wants.
    const employeeForm = this.element.querySelector('.employee__form');
    employeeForm.style.display = 'block';
  }

  init() {
    const {
      contactButton,
    } = this.children;
    if (! contactButton) {
      return;
    }
    contactButton.addEventListener('click', (e) => this.clickHandler(e));
  }
}
